import { useProofRebrand } from "util/feature_detection";

export const COLOR = {
  BLUE: "#0046fa", // --primary-50
  PURPLE: "#4A306D", // $accent-secondary-60
  ORANGE: "#c36b12", // $accent-tertiary-60
  SIGNER_1: "#00237d", // --primary-80
  SIGNER_2: "#237a26", // --success-80
  SIGNER_3: "#840018", // $danger-80
  SIGNER_4: "#006486",
  SIGNER_5: "#840011",
  SIGNER_6: "#0f4848", // $accent-primary-80
  SIGNER_7: "#A40061",
  SIGNER_8: "#1A0DA4",
  SIGNER_9: "#4C00A6",
  SIGNER_10: "#7A7A00",
  SUCCESS: "#25a631", // --success-60
  DANGER: "#d32f2f", // $danger-50;
};

export type COLOR = (typeof COLOR)[keyof typeof COLOR];
export type COLORS = typeof COLOR;

export enum DeprecatedColor {
  BLUE = "#1175d1", // --primary-50
  PURPLE = "#4A306D", // $accent-secondary-60
  ORANGE = "#c36b12", // $accent-tertiary-60
  SIGNER_1 = "#0d3574", // --primary-80
  SIGNER_2 = "#177038", // --success-80
  SIGNER_3 = "#840018", // $danger-80
  SIGNER_4 = "#006486",
  SIGNER_5 = "#840011",
  SIGNER_6 = "#0f4848", // $accent-primary-80
  SIGNER_7 = "#A40061",
  SIGNER_8 = "#1A0DA4",
  SIGNER_9 = "#4C00A6",
  SIGNER_10 = "#7A7A00",
  SUCCESS = "#36B37E", // --success-50
  DANGER = "#d32f2f", // $danger-50;
}

export function useColorConstant() {
  const isProof = useProofRebrand();
  if (isProof) {
    return COLOR;
  }
  return DeprecatedColor;
}
